import { defineMessages } from 'react-intl';

export const mcpDetailsMessages = defineMessages({
  detailsTitle: {
    id: 'oauth.mcp.details.title',
    defaultMessage: 'Details',
    description: 'Section heading for MCP app details',
  },
  nameLabel: {
    id: 'oauth.mcp.details.nameLabel',
    defaultMessage: 'Name',
    description: 'Label for the app name detail row',
  },
  domainLabel: {
    id: 'oauth.mcp.details.domainLabel',
    defaultMessage: 'Domains',
    description: 'Label for the Domain URL detail row',
  },
});
